import * as CONFIG from "../environments/config";

export const getConfigByEnv = (env: string | undefined) => {
  if (env === "dev" || env === "qa" || env === "prod") {
    return CONFIG[env];
  }
  // Valor por defecto o lanza error si el env no es válido
  throw new Error("REACT_APP_ENV no está definido o es inválido");
};